import(/* webpackMode: "eager", webpackExports: ["default"] */ "/Users/panxo/Development/QC-AI/web/node_modules/next-intl/dist/esm/production/shared/NextIntlClientProvider.js");
;
import(/* webpackMode: "eager" */ "/Users/panxo/Development/QC-AI/web/node_modules/next/font/google/target.css?{\"path\":\"src/app/[locale]/layout.tsx\",\"import\":\"Barlow\",\"arguments\":[{\"subsets\":[\"latin\"],\"weight\":[\"400\",\"500\",\"600\",\"700\"]}],\"variableName\":\"barlow\"}");
;
import(/* webpackMode: "eager", webpackExports: ["PostHogProvider"] */ "/Users/panxo/Development/QC-AI/web/src/components/PostHogProvider.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["SentryProvider"] */ "/Users/panxo/Development/QC-AI/web/src/components/SentryProvider.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["AuthProvider"] */ "/Users/panxo/Development/QC-AI/web/src/context/AuthContext.tsx");
;
import(/* webpackMode: "eager" */ "/Users/panxo/Development/QC-AI/web/src/styles/globals.css");
